import PageShell from "@/components/PageShell";
import FadeIn from "@/components/FadeIn";
import { useMortgageCalculator, MortgageCalculator } from "@/components/Calculator";
import BuyingPower from "@/components/BuyingPower";
import Comparison from "@/components/Comparison";

export default function CalculatorPage({ onLead }) {
  const calc = useMortgageCalculator();
  return (
    <PageShell backdrop="/homes/scale-1250.webp" title="Mortgage Calculator — My First Home Mortgage Ltd">
      <section data-testid="calculator-page-hero" className="pt-14 pb-24 lg:pb-32">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
          <FadeIn className="lg:col-span-6">
            <p className="gold-label mb-6">Mortgage Calculator</p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tighter leading-[1.05] text-ivory">
              MODEL YOUR PAYMENT,
              <br />
              <span className="gold-text-gradient italic">BEFORE YOU COMMIT.</span>
            </h1>
            <p className="mt-6 text-base md:text-lg text-ivory/65 font-light leading-relaxed max-w-lg">
              Adjust price, down payment, rate and amortization to see a clear estimate — then explore your buying power and compare structures below.
            </p>
          </FadeIn>
          <FadeIn className="lg:col-span-6" delay={0.15}>
            <MortgageCalculator calc={calc} onLead={onLead} />
          </FadeIn>
        </div>
      </section>
      <BuyingPower onLead={onLead} />
      <Comparison />
    </PageShell>
  );
}
